import React, { FC } from 'react';
import { Badge, Collapse, Tag, Typography } from 'antd';

import { IServiceItem } from 'types/recommendations.types';

interface Props<T> {
  items: T[];
  onRemove: (item: T) => void;
  getRowKey: (item: T) => string;
}

export const RecommendationsSelectedItems: FC<Props<IServiceItem>> = ({
  items,
  getRowKey,
  onRemove
}) => {
  return (
    <Badge.Ribbon text={items.length}>
      <Collapse>
        <Collapse.Panel key="items" header="Выбранные услуги">
          {items.map(item => (
            <Tag
              onClose={() => onRemove(item)}
              closable
              style={{ maxWidth: "100%", margin: "4px", display: "inline-flex" }}
              key={getRowKey(item)}
            >
              <Typography.Text ellipsis>{item.name} ({item.city.name})</Typography.Text>
            </Tag>
          ))}
        </Collapse.Panel>
      </Collapse>
    </Badge.Ribbon>
  );
};